<template>
  <div class="n-item">
    <UiIcon
      v-if="item.status >= 0"
      :icon="getIconUpload(item.fileType)" :class="item.status === 3 ? 'text-emerald-500' : 'text-neutral-800 dark:text-neutral-300'"
      :size="30"
    />
    <UiIcon v-else icon="cloud-off" :size="30" class="text-red-500" />

    <div class="grow">
      <div class="clamp-lines font-semibold mb-2">{{ item.name }}</div>

      <Transition
        mode="out-in"
        enter-active-class="transform transition-all duration-300"
        enter-from-class="opacity-0 -translate-x-2"
        leave-active-class="transform transition-all duration-300"
        leave-to-class="opacity-0 translate-x-2"
      >
        <div v-if="item.status < 0" class="w-full text-sm font-semibold text-red-500">
          {{ item.status === -2 ? 'Upload cancelado' : 'Upload interrompido' }}
        </div>
        <div v-else-if="item.status === 0" class="w-full text-sm font-semibold text-neutral-600">
          Iniciando...
        </div>
        <div v-else-if="item.status === 1" class="w-full text-sm font-semibold text-neutral-600">
          Enviando... 
          <div class="text-sm italic text-gray-500">
            <span>{{ item.loaded }} - </span> {{ item.total }} <span>({{ item.progress }}%)</span>
          </div>
        </div>
        <div v-else-if="item.status === 2" class="mt-1 flex items-center justify-start gap-2 text-blue-400">
          <UiIcon icon="loader" :size="14" class="animate-spin" /> Finalizando upload...
        </div>
        <div v-else-if="item.status === 3" class="w-full text-sm font-semibold text-emerald-500">
          Upload finalizado {{ item.total }}
        </div>
      </Transition>
    </div>

    <div
      class="rounded-full w-6 h-6 flex items-center justify-center border border-solid border-neutral-300 text-neutral-400 transition-all hover:border-red-400 hover:text-red-400 cursor-pointer"
      :title="item.status >= 0 && item.status < 3 ? 'Cancelar Upload' : 'Limpar'"
      @click="item.status >= 0 && item.status < 3 ? midiaStore.cancelTransfer(item.id) : midiaStore.removeTransfer(item.id)"
    >
      <UiIcon icon="x" :weight="200" :size="16" />
    </div>

    <div class="absolute bottom-0 left-0 h-0 w-full rounded-md bg-[#DDD] transition-all" :class="{ '!h-1': item.status === 1 }">
      <div
        class="text-sm h-full rounded-md bg-emerald-400 transition-all duration-1000"
        :style="{ width: `${item.progress}%` }"
      >
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useMidiaStore } from '@/stores'
import UiIcon from '@/components/ui/icon.vue'
import type { FileTransferType } from '@/types/types'

const midiaStore = useMidiaStore()

defineProps<{
  item: FileTransferType
}>()

const getIconUpload = (type: string) => {
  if (type === 'application/pdf') return 'file-type-pdf'
  if (type.startsWith('image/')) return 'photo'
  if (type.startsWith('audio/')) return 'file-music'
  if (type.startsWith('video/')) return 'video'
  if (type.split('.')?.pop()?.toLowerCase() === 'zip') return 'file-type-zip'
  return 'cloud-upload'
}
</script>

<style scoped lang="scss">
.n-item {
  @apply border-0 border-b border-solid border-b-neutral-200 flex w-full items-center gap-2 box-border;
}

.n-item:last-of-type {
  @apply border-0;
}

.clamp-lines {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>